/* Trottibike Urban : apparition des blocs au défilement (IntersectionObserver). */
(() => {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
  );

  const watch = (scope) => scope.querySelectorAll('.tb-reveal:not(.is-in)').forEach((el) => observer.observe(el));
  watch(document);

  // Éditeur de thème : réobserver les sections rechargées
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.tb-reveal').forEach((el) => el.classList.add('is-in'));
  });
})();
